import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import IFrame from "../../components/IFrame";
import { useStores } from "../../hooks/use-stores";

const FRAMER_EN_URL = "https://mystarfishperks.framer.website/en/programs-explanations/marketing-system";
const FRAMER_FR_URL = "https://mystarfishperks.framer.website/fr/program-explainations/marketing-system";

function MarketingSystem() {
    const { commonStore } = useStores();
    const { language } = commonStore;

    const framerUrl = useMemo(() => {
        const lang = String(language || "en").toLowerCase();
        return lang.startsWith("fr") ? FRAMER_FR_URL : FRAMER_EN_URL;
    }, [language]);

    return <IFrame url={framerUrl} />;
}

export default observer(MarketingSystem);
